var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTxt = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3C2.39431 3 0.973684 4.44367 0.973684 6.20259V14.7974C0.973684 16.5563 2.39431 18 4.16833 18H32.8317C34.6057 18 36.0263 16.5563 36.0263 14.7974V6.20259C36.0263 4.44368 34.6057 3 32.8317 3H4.16833ZM0 6.20259C0 3.87174 1.87589 2 4.16833 2H32.8317C35.1241 2 37 3.87174 37 6.20259V14.7974C37 17.1283 35.1241 19 32.8317 19H4.16833C1.87589 19 0 17.1283 0 14.7974V6.20259Z",
    fill: "#0072FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1066 8.2516V7H9.99993V8.2516H11.7527V13.5H13.3364V8.2516H15.1066Z",
    fill: "#0072FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7235 13.5L18.3499 11.4767L17.1691 13.5H15.3643L17.4464 10.1538L15.2993 7H17.1691L18.5059 8.9584L19.6585 7H21.4546L19.4006 10.2727L21.5932 13.5H19.7235Z",
    fill: "#0072FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.882 8.2516V7H21.7776V8.2516H23.5281V13.5H25.1141V8.2516H26.882Z",
    fill: "#0072FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTxt);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/txt.77e0ea0d8bd144df9f98f160d1a7499a.svg";